import { render, staticRenderFns } from "./TheTopMenu.vue?vue&type=template&id=efa7c7e8&scoped=true&"
import script from "./TheTopMenu.vue?vue&type=script&lang=ts&"
export * from "./TheTopMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TheTopMenu.vue?vue&type=style&index=0&id=efa7c7e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa7c7e8",
  null
  
)

export default component.exports